"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomElement = void 0;
const randomElement = (arr) => () => arr[Math.floor(Math.random() * arr.length)];
exports.randomElement = randomElement;
